import BuildLineLayout from '../../../../../containers/BuildLineLayout'
import {UpdateProvider} from '../../../../../contexts/update'
import {PlaceIdList} from '../../../../../plugins/plugins.types'
import Plugin from '../../../../common/Plugin/Plugin'

import CollapsibleBranchLines from './CollapsibleBranchLines/CollapsibleBranchLines.container'
import {BranchesToShow} from './CollapsibleBranchLines/CollapsibleBranchLines.types'

type Props = {
  fetchCurrentBranches: () => unknown
}
export default function BuildTypeBranches({fetchCurrentBranches}: Props) {
  return (
    <UpdateProvider update={fetchCurrentBranches}>
      <Plugin placeId={PlaceIdList.SAKURA_BUILD_CONFIGURATION_BRANCHES} />
      <BuildLineLayout showPath={false} showBranch={false}>
        <CollapsibleBranchLines branchesToShow={BranchesToShow.DEFAULT} />
        <CollapsibleBranchLines branchesToShow={BranchesToShow.NON_DEFAULT} withTitle />
        <CollapsibleBranchLines branchesToShow={BranchesToShow.NON_BUILT} withTitle />
      </BuildLineLayout>
    </UpdateProvider>
  )
}
